import { useEffect, useContext, useState } from 'react'
import { ReactComponent as MailIcon } from 'static/img/envelope-transparent.svg'
import { ReactComponent as TextIcon } from 'static/img/message-bubble-transparent.svg'
import { ReactComponent as KebabMenuIcon } from 'static/img/kebab-menu-transparent.svg'
import { isMobile } from 'utils/helpers'
import { track } from 'utils/analytics-tracker'
import { SessionContext } from '../context'
import styles from './ShareBubbles.module.scss'
import classNames from 'classnames'

export const ShareBubbles = ({
  shareLink,
  noLabel = false,
  className,
  bubbleContainerCls = styles.bubbleContainer,
  bubbleCls = styles.bubble,
  iconColor = 'white',
  mailProps,
  textProps,
  kebabMenuProps,
  header = 'Share link via:',
  headerClassName,
  text,
  subject,
  eventPayload = {},
  event,
  shareSource
}: Props) => {
  const [canShare, setCanShare] = useState(false)
  const context = useContext(SessionContext)

  useEffect(() => {
    // @ts-ignore
    navigator.share && setCanShare(true)
  }, [])
  
  const message = `${text} ${shareLink}`
  const title = 'Invite'
  const shareDetails = { url: shareLink, title, text }

  const handleInviteShared = async () => {
    if (canShare) {
      try {
        await navigator.share(shareDetails).then(() => {
          console.log('Success')
        })
      } catch (error) {
        console.error(`Invite Sharing failed: ${error}`)
      }
    } else {
      console.warn('Web share not supported...')
    }
  }

  const bubbleOptions = [
    {
      icon: (
        <MailIcon
          width={mailProps?.iconWidth || 34}
          style={{
            color: iconColor,
            ...mailProps?.iconStyle
          }}
        />
      ),
      label: 'email',
      href: `mailto:?subject=${subject}&body=${message}`,
      canShow: !context.mobileAppFromV(2),
      shareType: 'email'
    },
    {
      icon: (
        <TextIcon
          width={textProps?.iconWidth || 36}
          height={textProps?.iconHeight || 34}
          style={{
            color: iconColor,
            position: 'relative',
            top: 3,
            ...textProps?.iconStyle
          }}
        />
      ),
      label: 'text',
      href: `sms:?&body=${message}`,
      canShow: !context.mobileAppFromV(2),
      shareType: 'SMS'
    },
    {
      icon: (
        <KebabMenuIcon
          width={kebabMenuProps?.iconWidth || 23}
          style={{
            color: iconColor,
            ...kebabMenuProps?.iconStyle
          }}
        />
      ),
      label: 'other',
      href: "#",
      onClick: handleInviteShared,
      canShow: isMobile() && canShare,
      shareType: 'sharesheet'
    }
  ]
  if (context.mobileAppFromV(2) && context.platform === 'android') return null
  return (
    <>
      <p className={headerClassName}>{header}</p>
      <div className={classNames(styles.bubbles, className)}>
        {bubbleOptions.map((option: any, idx: any) => {
          const { canShow, label, href, icon, onClick, shareType } = option
          if (!canShow) return null

          const newEventPayload = {
            ...eventPayload,
            shareType,
            shareSource
          }
          return (
            <a
              className={bubbleContainerCls}
              href={href}
              key={idx}
              onClick={(e) => {
                onClick && e.preventDefault()
                onClick && onClick()
                track(event, newEventPayload)
              }}
            >
              <div className={bubbleCls}>
                {icon}
              </div>
              {!noLabel && <p>{label}</p>}
            </a>
          )
        })}
      </div>
    </>
  )
}

interface Props { 
  shareLink: string
  noLabel?: boolean
  className?: string
  bubbleContainerCls?: string
  bubbleCls?: string
  iconColor?: string
  mailProps?: {
    iconWidth?: number,
    iconStyle?: {}
  }
  textProps?: {
    iconWidth?: number,
    iconHeight?: number,
    iconStyle?: {}
  }
  kebabMenuProps?: {
    iconWidth?: number,
    iconStyle?: {}
  }
  header?: string
  headerClassName?: string
  text: string
  subject: string
  eventPayload?: Object
  event: 'FundLinkShare' | 'ReferralLinkShare' | 'FamilyUpdateShare'
  shareSource: 'editor' | 'fund page' | 'fund settings' | 'gifting page'
}